import './App.css';
import Allroutes from './routes/Allroutes/Allroutes';

function App() {
  return (
    <div>
      <Allroutes/>
    </div>
  );
}

export default App;
